import { Button, Card } from "@rumbledirect/ui";
import { Typography } from "antd";

export interface ActionCardProps {
  title: string;
  description: string;
  action: {
    url: string;
    text: string;
  };
}

export const ActionCard = ({ title, description, action }: ActionCardProps) => {
  return (
    <Card title={title}>
      <Typography.Paragraph style={{ whiteSpace: "pre-line" }}>
        {description}
      </Typography.Paragraph>
      <Button
        href={action.url}
        target="_blank"
        rel="noopener noreferrer"
        type="primary"
        style={{ width: "100%", marginTop: 15 }}
      >
        {action.text}
      </Button>
    </Card>
  );
};
